/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_6_DInputs */

const en_mk_tut_gl_6_d = /** @type {(inputs: Mk_Tut_Gl_6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A way of working written once and reused by many agents.`)
};

const id_mk_tut_gl_6_d = /** @type {(inputs: Mk_Tut_Gl_6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara kerja yang ditulis sekali lalu dipakai ulang oleh banyak agen.`)
};

/**
* | output |
* | --- |
* | "A way of working written once and reused by many agents." |
*
* @param {Mk_Tut_Gl_6_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_6_d = /** @type {((inputs?: Mk_Tut_Gl_6_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_6_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_6_d(inputs)
	return en_mk_tut_gl_6_d(inputs)
});